import {
  GET_ACCUMULATED_AMOUNT,
  GET_ACCUMULATED_AMOUNT_ERROR,
  GET_ACCUMULATED_AMOUNT_SUCCESS,
  GET_ACCUMULATED_AMOUNT_DETAIL,
  GET_ACCUMULATED_AMOUNT_DETAIL_ERROR,
  GET_ACCUMULATED_AMOUNT_DETAIL_SUCCESS,
  SET_CUMULATIVE_AMOUNT_YEAR_SUCCESS
} from './HomeTradedAmounts.actions'

const homeTradedAmountsState = {
  accumulatedAmount: [],
  accumulatedAmountDetail: [],
  cumulativeAmountYear: {},
  error: null,
  loading: false
}

/**
 * The homeTradedAmounts's reducer.
 */
const homeTradedAmountsReducer = (state = homeTradedAmountsState, { payload, type }) => {
  switch (type) {
    case (GET_ACCUMULATED_AMOUNT, GET_ACCUMULATED_AMOUNT_DETAIL): {
      return { ...state, loading: true }
    }
    case (GET_ACCUMULATED_AMOUNT_ERROR, GET_ACCUMULATED_AMOUNT_DETAIL_ERROR): {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ACCUMULATED_AMOUNT_SUCCESS: {
      return { ...state, loading: false, accumulatedAmount: payload.accumulatedAmount }
    }
    case GET_ACCUMULATED_AMOUNT_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        accumulatedAmountDetail: [...state.accumulatedAmountDetail, payload.accumulatedAmountDetail]
      }
    }
    case SET_CUMULATIVE_AMOUNT_YEAR_SUCCESS: {
      return {
        ...state,
        cumulativeAmountYear: payload
      }
    }
    default: {
      return state
    }
  }
}

export default homeTradedAmountsReducer
